import { put, takeLatest } from 'redux-saga/effects';

import { safeAsync } from '@occc-app/lib/safeAsync';
import { types as offerTypes, ActionCreators as OfferActionCreators } from '@occc-app/Offer/redux';

import actions from './actions';
import { deserializeOffer } from './deserializers';

function* deserializeOfferMetaData(action: ReturnType<OfferActionCreators['RequestOfferOK']>) {
  const getStartedMetaData = deserializeOffer(action.offerAttributes);
  yield put(actions.requestGetStartedDataOK(getStartedMetaData));
}

const sagas = {
  deserializeOfferMetaData: safeAsync(deserializeOfferMetaData),
};

export default function* saga() {
  yield takeLatest(offerTypes.REQUEST_OFFER_OK, sagas.deserializeOfferMetaData);
}
